import {type FC, useEffect } from "react";
import { useMessageInsightStore } from "../../store/useMessageInsightStore";
import type { RiskLevel } from "../../types/messageInsight";
import { axiosInstance } from "../../lib/axios";

interface Props {
  messageId: string;
}

const riskColor: Record<RiskLevel, string> = {
  Low: "bg-green-100 text-green-700",
  Medium: "bg-yellow-100 text-yellow-700",
  High: "bg-red-100 text-red-700",
};

const AIInsightSidebar: FC<Props> = ({ messageId }) => {
  const insight = useMessageInsightStore(
    (state) => state.insights[messageId]
  );

useEffect(() => {
  if (!insight) {
    axiosInstance
      .get(`/ai/message-insight/${messageId}`)
      .then((res) => {
        if (res.data) {
          useMessageInsightStore.getState().addInsight(res.data);
        }
      })
      .catch(() => {});
  }
}, [messageId]);

  if (!insight) {
    return (
 <div className="flex items-center gap-2 mt-2
text-xs text-blue-600 bg-blue-50
px-3 py-2 rounded-lg w-fit">
  <span className="animate-spin h-3 w-3 rounded-full
border-2 border-blue-400 border-t-transparent" />
  Analyzing insight…
</div>

    );
  }

  return (
   <div className="mt-2 p-3 bg-white border
rounded-xl shadow-sm space-y-2
relative before:absolute before:-top-2 before:left-4
before:w-3 before:h-3 before:bg-white
before:border-l before:border-t before:rotate-45">

      <span
        className={`inline-flex items-center gap-1
px-2.5 py-0.5 text-[11px]
font-medium rounded-full ${riskColor[insight.riskLevel]}`}
      >
        Risk: {insight.riskLevel}
      </span>

      {insight.summary.length > 0 && (
        <div>
<p className="text-[11px] font-semibold text-gray-600 uppercase tracking-wide">
  Summary
</p>
          <ul className="list-disc pl-4 text-xs text-gray-700">
            {insight.summary.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      )}

      {insight.risks.length > 0 && (
        <div>
          <p className="text-[11px] font-semibold text-red-600 uppercase tracking-wide">
  Risks
</p>

          <ul className="list-disc pl-4 text-xs text-red-500">
            {insight.risks.map((risk, index) => (
              <li key={index}>{risk}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default AIInsightSidebar;
